import { render, staticRenderFns } from "./companyCards.vue?vue&type=template&id=0ef65715&scoped=true&"
import script from "./companyCards.vue?vue&type=script&lang=js&"
export * from "./companyCards.vue?vue&type=script&lang=js&"
import style0 from "./companyCards.vue?vue&type=style&index=0&id=0ef65715&lang=scss&scoped=true&"
import style1 from "./companyCards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef65715",
  null
  
)

export default component.exports